module.exports = __webpack_public_path__ + "images/trees-701de963e2.png";